var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('svg',{staticClass:"chart",attrs:{"width":"420","height":"120"}}),_vm._v("\n  "+_vm._s(_vm.valuesArr)+" "+_vm._s(_vm.options)+"\n\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be92e62a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/survey/D3Bar.vue
// module id = null
// module chunks = 